import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'logged_out_retailers-auto_signup_modal-view';

/**
 * Event track for view the auto sign-up modal pop-up for logged-out retailers
 */
export function trackLoggedOutRetailersAutoSignupModalView(
  currentPath: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { currentPath },
  });
}
